<div class="ziro-admin-page-content">
  <ziro-loading-block [hidden]="!isLoading"></ziro-loading-block>

  <div class="col-md-10 offset-md-1 pb-2" [hidden]="isLoading">
    <ziro-breadcrumbs></ziro-breadcrumbs>

    <div class="mb-3 list-group list-group-striped border-rad-all-12 card-shadow">
      @for (config of formConfig.fields | keyvalue: returnZero; track config) {
        <div class="list-group-item position-relative">
          @if (isTextInput(config.value)) {
            <ziro-general-settings-text [fieldId]="config.key"></ziro-general-settings-text>
          }
          @if (isCheckBox(config.value)) {
            <ziro-general-settings-checkbox [fieldId]="config.key"></ziro-general-settings-checkbox>
          }
        </div>
      }
    </div>
  </div>
</div>

<ziro-bottom-nav></ziro-bottom-nav>
